import React, { useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import URL from '../../constants/urls'
import { checkStartCitationWarning, getPartnerDetails, isKeyInLocalStorage, isLoggedIn, isPermissionExist } from '../../utils/helper'
import { EMPTY_OBJECT } from '../../constants/globalConstants'
import whitepng from '../../assets/img/whitebg.png'
import { useNavigate } from 'react-router-dom'
import ModalLogin from './modalLogin'


function NavbarComponent(props) {
	const { partnerDetails, notify } = props
	const partner = window.location.toString().split('/')[3]
	const citation = window.location.toString().split('/')[5]
	const isCitation = localStorage.getItem('citation')
	const [show, setShow] = useState(false)
	const ispreviousHistory = isKeyInLocalStorage('previousHistory')
	
	// for the navigation 
	const navigate = useNavigate()
	
	const handleDetails = () => {
		navigate(`/${partner}/previousHistory/${citation ? citation : ''}`)
	}
	const handleBack = () => {
		if (window.history.length > 0) {
			navigate(-1)
		}
	}

	const handleLoginModalOpen = () => {
		setShow(true)
	}

	const handleLogout = () => {
		const citationNo = localStorage.getItem('citation')
		localStorage.removeItem('partnerData')
		localStorage.removeItem('access_token')
		localStorage.removeItem('userData')
		navigate(`/${partner}/autogate-citation-payment-details/${citationNo}`)
		navigate(0)
	}
	return (
		<header>
			<div className="container-fluid p-1 pb-2 border-bottom  border-primary">
				<div className='d-flex justify-content-between align-items-center text-primary'>
					<div className='d-flex g-1 align-content-center'>
						{window.history.length > 1 ? <button className='btn btn-sm px-1 btn-default' onClick={() => handleBack()} ><i className='fa fa-chevron-left'></i></button> : null}
						<img  className="logo" src={partnerDetails ? partnerDetails?.brand_setting ? partnerDetails?.brand_setting?.logourl : partnerDetails?.partner_details?.brand_setting?.logourl : getPartnerDetails()?.brand_setting ? getPartnerDetails()?.brand_setting?.logourl ? getPartnerDetails()?.brand_setting?.logourl : getPartnerDetails()?.parter_details?.brand_setting?.logourl : partner == 'townsend' ? whitepng : URL?.PARKENGAGE_LOGO_URL} alt={getPartnerDetails()?.name} />
					</div>
					<h6 className='m-0' >{(checkStartCitationWarning(isCitation) == 'WA') ? 'Warning' : (checkStartCitationWarning(isCitation) == 'CI') ? 'Citation' : ''}</h6>
					<div className='d-flex gap-1 align-items-center justify-content-end'>
						<a className='btn btn-sm p-0' onClick={handleDetails}> {(ispreviousHistory) ? ' View Details' : ''}</a>
						<div className="d-flex position-relative">
							{(isPermissionExist('Access Permissions', 'Citation Login') && !isLoggedIn()) ? <button type="button" className="btn btn-sm btn-default" onClick={handleLoginModalOpen}><i className='fa fa-user'></i></button> : null}
							{(isLoggedIn()) ?
								<button type="button" className="btn btn-sm btn-default dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" aria-expanded="false">
									<span className="visually-hidden">Toggle Dropdown</span>
								</button> : null}
							{(isLoggedIn()) ? <ul className="dropdown-menu">
								{/* <li><a className="dropdown-item" href="#"></a></li> */}
								{/* <li><hr className="dropdown-divider" /></li> */}
								<li><button className="dropdown-item" onClick={(e) => handleLogout(e)}>Logout</button></li>
							</ul> : null}
						</div>
					</div>
				</div>
			</div>
			<ModalLogin setShow={setShow} show={show} partnerDetails={partnerDetails} notify={notify} />
		</header>
	)
}


NavbarComponent.propTypes = {
	dispatch: PropTypes.func,
	isAuthenticated: PropTypes.bool,
	userData: PropTypes.object,
	permitData: PropTypes.object,
	isModalOpen: PropTypes.bool,
	partnerDetails: PropTypes.object,
	// isNavigated: PropTypes.string,
	notify: PropTypes.func,
}

NavbarComponent.defaulProps = {
	dispatch: noop,
	isAuthenticated: false,
	partnerDetails: EMPTY_OBJECT,
	// isNavigated: '',
	notify: noop,
}

function mapStateToProps() {
	return {}
}
export default connect(mapStateToProps)(NavbarComponent)
